<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue';
const props = defineProps<{
  value: number;
  totalCol: number;
  index: number;
  cols: number[];
  area?: HTMLElement;
}>();

let isDown = false;
const emit = defineEmits<{
  (e: 'update-position'): void;
  (e: 'on-update-position', index: number, value: number): void;
}>();

const onMouseDown = () => {
  if (props.totalCol > 4) return;
  isDown = true;
  document.body.classList.add('cursor-col-resize', 'dragging', 'pointer-events-none');
  document.addEventListener('mousemove', onMouseMove);
};
const onMouseMove = (e: MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
  if (props.area) {
    const rect = props.area.getBoundingClientRect();
    const fullWidth = rect.width;
    const itemWidth = Math.round(fullWidth / 12);
    let x = e.clientX - rect.left;
    if (x > rect.width) {
      x = rect.width;
    }
    if (x < 0) {
      x = 0;
    }
    const position = Math.round(x / itemWidth);
    emit('on-update-position', props.index, position);
  }
};

const onMouseUp = () => {
  if (isDown) {
    isDown = false;
    emit('update-position');
  }

  document.body.classList.remove('cursor-col-resize', 'dragging', 'pointer-events-none');
  document.removeEventListener('mousemove', onMouseMove);
};
onMounted(() => {
  document.addEventListener('mouseup', onMouseUp);
});

onUnmounted(() => {
  document.removeEventListener('mouseup', onMouseUp);
});
</script>

<template>
  <div
    draggable="false"
    class="bg-dark-400 text-12 font-regular flex select-none items-center justify-center text-center">
    {{ value }}
  </div>
  <div
    v-if="totalCol > 1 && index !== totalCol - 1"
    draggable="false"
    :class="{ 'bg-dark-100': totalCol > 4, 'bg-primary-300 cursor-col-resize': totalCol <= 4 }"
    class="w-4 rounded-full"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"></div>
</template>
